import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "918618396055";

export default function WhatsAppButton() {
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=Hi%20OSAA%2C%20I%E2%80%99d%20like%20to%20know%20more%20about%20your%20programs.`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-7 h-7" />
    </a>
  );
}
